import {
  type UseFormRegister,
  type FieldValues,
  type FieldPath,
  type RegisterOptions,
  type UseFormRegisterReturn,
} from "react-hook-form";

export function useTrimmedRegister<TFieldValues extends FieldValues>(
  register: UseFormRegister<TFieldValues>,
) {
  return function registerTrimmed<TName extends FieldPath<TFieldValues>>(
    name: TName,
    options?: RegisterOptions<TFieldValues, TName>,
  ): UseFormRegisterReturn<TName> {
    const merged: RegisterOptions<TFieldValues, TName> = {
      ...options,
      setValueAs: (value: unknown) => {
        const base = options?.setValueAs ? options.setValueAs(value) : value;
        return typeof base === "string" ? base.trim() : base;
      },
    };
    return register(name, merged);
  };
}
